import React, { FunctionComponent } from "react";
import { MaintenancePage } from "./component";

export const MaintenancePageContainer: FunctionComponent = () => {
  return <MaintenancePage />;
};
